<script setup lang="ts">
import { Form, Head } from '@inertiajs/vue3'

import SettingsCard from '@/components/settings/SettingsCard.vue'
import SettingsPanel from '@/components/settings/SettingsPanel.vue'
import { firstFormError } from '@/lib/forms'
import { dashboardLayout } from '@/lib/layouts'
import { adminSettingsPasswordPath } from '@/routes'

defineOptions({
  layout: dashboardLayout,
})
</script>

<template>
  <Head title="Password settings" />

  <SettingsPanel
    title="Settings"
    description="Manage profile, security, sessions, and appearance preferences."
  >
    <SettingsCard
      title="Password"
      description="Use a strong password to protect account access."
      icon="i-lucide-lock-keyhole"
    >
      <Form
        v-slot="{ errors, processing, recentlySuccessful }"
        class="max-w-2xl space-y-5"
        method="put"
        :action="adminSettingsPasswordPath()"
        :options="{ preserveScroll: true }"
        reset-on-error
        reset-on-success
      >
        <UFormField
          label="Current password"
          name="password_challenge"
          :error="firstFormError(errors.password_challenge)"
          required
        >
          <UInput
            id="password_challenge"
            name="password_challenge"
            type="password"
            autocomplete="current-password"
            placeholder="Current password"
            icon="i-lucide-lock-keyhole"
            class="w-full"
          />
        </UFormField>

        <UFormField
          label="New password"
          name="password"
          :error="firstFormError(errors.password)"
          required
        >
          <UInput
            id="password"
            name="password"
            type="password"
            autocomplete="new-password"
            placeholder="New password"
            icon="i-lucide-key-round"
            class="w-full"
          />
        </UFormField>

        <UFormField
          label="Confirm password"
          name="password_confirmation"
          :error="firstFormError(errors.password_confirmation)"
          required
        >
          <UInput
            id="password_confirmation"
            name="password_confirmation"
            type="password"
            autocomplete="new-password"
            placeholder="Confirm password"
            icon="i-lucide-key-round"
            class="w-full"
          />
        </UFormField>

        <div class="flex items-center gap-3">
          <UButton
            type="submit"
            label="Save password"
            icon="i-lucide-save"
            :loading="processing"
          />

          <Transition
            enter-active-class="transition ease-in-out"
            enter-from-class="opacity-0"
            leave-active-class="transition ease-in-out"
            leave-to-class="opacity-0"
          >
            <UBadge
              v-show="recentlySuccessful"
              color="success"
              variant="subtle"
              icon="i-lucide-check"
            >
              Saved
            </UBadge>
          </Transition>
        </div>
      </Form>
    </SettingsCard>
  </SettingsPanel>
</template>
